import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const pulseAnimationDriverFactory = (base, body) => {
  return {
    ...baseUniDriverFactory(base, body),
  };
};
